import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { InstructionsItemProps } from '../../interfaces/components';

const InstructionItem = ({ Icon, text }: InstructionsItemProps) => {
  return (
    <Box display="flex" gap="5" alignItems="center" w={['290px', '290px', '310px', '350px', '350px']}>
      <Box display="flex">
        <Image
          src={Icon}
          alt="icon"
          width={['70px', '70px', '65px', '70px']}
          height={['70px', '70px', '65px', '70px']}
          objectFit="contain"
          minW="70px"
        />
      </Box>

      <Box>
        <Text
          textAlign="left"
          fontSize={['16px', '16px', '18px', '20px', '20px']}
          // maxW={['140px', '180px', '180px', '250px', '250px']}
          width="auto"
          fontFamily="SangBleuBPLight"
          className="copy"
        >
          {text}
        </Text>
      </Box>
    </Box>
  );
};

export default InstructionItem;
